export const getLocalAccessToken = () => localStorage.getItem('access_token');

export const setLocalAccessToken = (token, date, expiresIn) => {
  localStorage.setItem('access_token', token);
  localStorage.setItem('access_token_date', date);
  localStorage.setItem('access_token_expires_in', expiresIn);
};

export const removeLocalAccessToken = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('access_token_date');
  localStorage.removeItem('access_token_expires_in');
  localStorage.removeItem('refresh_token');
};

export const getLocalRefreshToken = () => localStorage.getItem('refresh_token');

export const setLocalRefreshToken = (token) => {
  localStorage.setItem('refresh_token', token);
};
